import { Component, ElementRef, ViewChild, AfterViewInit, Input } from '@angular/core';
import { ExternalLinkService } from '../../../app/shared/utils/external-link.service';
import { NavParams, ModalController, IonicModule } from '@ionic/angular';
import { NewsIndispo, NewsIndispoCategorie } from '../../shared/providers/news-indispos/news-indispos.models';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'news-indispo-detail',
  templateUrl: './news-indispo-detail.component.html',
  styleUrls: ['./news-indispo-detail.component.scss'],
  standalone: true,
  imports: [IonicModule, CommonModule],
})
export class NewsIndispoDetailComponent implements AfterViewInit {
  /**
   * La news ou indispo à afficher
   */
  @Input()
  newsIndispo: NewsIndispo;

  /**
   * Enum categorie news indispo (utilisé dans le template)
   */
  NewsIndispoCategorie = NewsIndispoCategorie;

  @ViewChild('content') content: ElementRef;

  /**
   * Constructor
   */
  constructor(
    private madalCtrl: ModalController,
    private externalLinkService: ExternalLinkService
  ) {}

  ngAfterViewInit() {
    let links = this.content.nativeElement.querySelectorAll('a');

    for (let i = 0; i < links.length; i++) {
      let link = this.content.nativeElement.querySelectorAll('a')[i];

      link.addEventListener('click', (event) => {
        this.externalLinkService.ouvrirLien(event.target.dataset.link);
      });

      link.setAttribute('data-link', link.href);
      link.setAttribute('class', 'link-news-indispo');
      link.removeAttribute('href');
    }
  }

  /**
   * Dismiss de la modal
   */
  dismissModal() {
    this.madalCtrl.dismiss();
  }
}
